const nodes = [
  { name: 'AI Agents', icon: 'ri-robot-line', top: '8%', left: '50%', rot: -90 },
  { name: 'ERP', icon: 'ri-database-2-line', top: '17.8%', left: '77%', rot: -50 },
  { name: 'SAP', icon: 'ri-stack-line', top: '42.7%', left: '91.4%', rot: -10 },
  { name: 'APIs', icon: 'ri-links-line', top: '71%', left: '86.4%', rot: 30 },
  { name: 'Web', icon: 'ri-global-line', top: '89.5%', left: '64.4%', rot: 70 },
  { name: 'Mobile', icon: 'ri-smartphone-line', top: '89.5%', left: '35.6%', rot: 110 },
  { name: 'Payments', icon: 'ri-bank-card-line', top: '71%', left: '13.6%', rot: 150 },
  { name: 'Cloud', icon: 'ri-cloud-line', top: '42.7%', left: '8.6%', rot: 190 },
  { name: 'Data', icon: 'ri-bar-chart-2-line', top: '17.8%', left: '23%', rot: 230 },
];

export default function Ecosystem() {
  return (
    <div className="relative w-full max-w-[560px] mx-auto aspect-square select-none">
      {/* Orbiting rings */}
      <div className="absolute inset-[12%] rounded-full border border-background-700/50"></div>
      <div className="absolute inset-[28%] rounded-full border border-background-700/40"></div>
      <div className="absolute inset-0 rounded-full border border-dashed border-primary-500/20 animate-spin-slow"></div>

      {/* Connection lines */}
      {nodes.map((n) => (
        <div
          key={n.name}
          className="absolute left-1/2 top-1/2 h-[2px] w-[42%] bg-gradient-to-r from-primary-500/40 to-primary-500/5"
          style={{
            transformOrigin: '0 50%',
            transform: `rotate(${n.rot}deg)`,
          }}
        />
      ))}

      {/* Central node */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-primary-500/30 blur-xl animate-pulse-glow"></div>
          <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex flex-col items-center justify-center glow-primary">
            <span className="text-white font-bold font-heading tracking-widest text-sm md:text-base">
              ACOMA
            </span>
          </div>
        </div>
      </div>

      {/* Satellite nodes */}
      {nodes.map((n) => (
        <div
          key={n.name}
          className="absolute -translate-x-1/2 -translate-y-1/2 z-10 animate-float-slow"
          style={{ top: n.top, left: n.left, animationDelay: `${Math.random()}s` }}
        >
          <div className="group flex flex-col items-center gap-1.5">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-background-800/80 backdrop-blur border border-background-700/70 flex items-center justify-center text-primary-400 group-hover:text-primary-300 group-hover:border-primary-500/50 transition-colors">
              <i className={`${n.icon} text-xl md:text-2xl`}></i>
            </div>
            <span className="text-[10px] md:text-xs text-foreground-400 whitespace-nowrap font-medium">
              {n.name}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}